import { Stack, Box, Typography, Dialog } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions } from '../store/SettingSlice';
import { getImgPath } from '../store/JSTool';

export default function FeedSuccessAlert(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function closeTap() {
        dispatch(settingActions.showFeedSuccessAlert(false));
    }

    return (
        <Dialog
            PaperProps={{
                style: {
                    backgroundColor: 'white',
                    boxShadow: 'none',
                    position: 'relative',
                    borderRadius: '6px'
                },
            }}
            open={settingData.showFeedSuccessAlert}>

            <Stack sx={{
                width: settingData.isMobile ? '320px' : '480px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: 3,
                pb: 3,
            }}>

                <Typography
                    onClick={closeTap}
                    sx={{
                        fontSize: 22,
                        color: 'black',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '15px',
                        top: '10px'
                    }}>
                    x
                </Typography>

                <Box
                    component={'img'}
                    src={getImgPath('msg_gray.png')}
                    sx={{
                        height: settingData.isMobile ? '50px' : '120px',
                        ml: 3,
                    }} />

                <Typography sx={{
                    fontSize: settingData.isMobile ? 18 : 25,
                    fontFamily: 'Lexend Deca',
                    mt: 1,
                }}>
                    Thank you for reaching out.
                </Typography>


                <Typography sx={{
                    fontSize: settingData.isMobile ? 12 : 15,
                    fontWeight: 900,
                    mt: 0.5,
                }}>
                    We will get back to you as soon as possible.
                </Typography>

            </Stack>

        </Dialog>
    );
}

